import OpusRecorder from "opus-recorder"

import { rejectPromiseAfterTimeout } from "@/utils/time"

class AudioService {
	private recorder: OpusRecorder
	private recordedAudioFormat: string

	constructor () {
		this.recorder = new OpusRecorder({
			/**
			 * It is recommended to use waveWorker since it
			 * has the best performance among all the others. Besides,
			 * we can avoid audio crackling/stuttering due to React
			 * state updates.
			 */
			encoderPath: "/libs/waveWorker.min.js"
		})
		this.recordedAudioFormat = "audio/ogg"
	}

	async startRecording (): Promise<void> {
		this.recorder.start()
	}

	async finishRecording (): Promise<Blob> {
		const FINISH_RECORDING_TIMEOUT_IN_MILLISECONDS = 5000
		const TIMEOUT_ERROR_MESSAGE = "Não foi possível finalizar a gravação de áudio a tempo"

		const recordingPromise = new Promise<Blob>(resolve => {
			this.recorder.ondataavailable = arrayBuffer => {
				const blob = new Blob([arrayBuffer], {
					type: this.recordedAudioFormat
				})

				resolve(blob)
			}
		})

		await rejectPromiseAfterTimeout(
			this.recorder.stop(),
			FINISH_RECORDING_TIMEOUT_IN_MILLISECONDS,
			TIMEOUT_ERROR_MESSAGE
		)

		return rejectPromiseAfterTimeout(
			recordingPromise,
			FINISH_RECORDING_TIMEOUT_IN_MILLISECONDS,
			TIMEOUT_ERROR_MESSAGE
		)
	}
}

export default new AudioService()
